import { Navigate } from 'react-router-dom';
import useUserPermissions from '../hooks/useUserPermissions';

function LandingRedirect() {
  const {
    canAccessIncidentResolver,
    canAccessSnAnalysis,
    canAccessProdPerformance,
    canAccessAiGovernance,
    canAccessRunbooks,
    isLoading,
  } = useUserPermissions();

  if (isLoading) return null;

  // AI Governance is now the default landing page for roles that have access to it.
  if (canAccessAiGovernance()) {
    return <Navigate to="/genai-evals" replace />;
  }

  // Frontline-like roles should land on SN Analysis when it's their only feature.
  if (
    canAccessSnAnalysis() &&
    !canAccessIncidentResolver() &&
    !canAccessRunbooks() &&
    !canAccessProdPerformance()
  ) {
    return <Navigate to="/sn-analysis" replace />;
  }

  // Roles that have prod-performance but not runbooks land on the dashboard.
  if (canAccessProdPerformance() && !canAccessRunbooks()) {
    return <Navigate to="/prod-performance" replace />;
  }

  if (canAccessIncidentResolver()) {
    return <Navigate to="/incident_view" replace />;
  }

  if (canAccessSnAnalysis()) {
    return <Navigate to="/sn-analysis" replace />;
  }

  return <Navigate to="/no-access" replace />;
}

export default LandingRedirect;
